module.exports = __webpack_public_path__ + "img/books.9b1a074e.svg";